module.exports = __webpack_public_path__ + "img/red-padlock.711fe362.svg";